import { useState, useEffect } from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import axios from 'axios';
import qs from 'qs';


const Page5IncidencesFinancieresHypPart1 = (props) =>
{
    const blue = '#069BD3';
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;

    const [incidencesData, setIncidencesData] = useState(null);

    async function getDatas() {
        // Convertir le numéro d'hypothèse en clé (1 -> h1, 2 -> h2, 3 -> h3)
        const hypotheseMap = { 1: 'h1', 2: 'h2', 3: 'h3' };
        const hypotheseKey = hypotheseMap[props.hypothese];
        const annee_debut = props.user.config_budget.retro_an_deb;
        const annee_fin = props.user.config_budget.prosp_an_fin;

        if (annee_debut === undefined || annee_fin === undefined) {
            console.warn('Les années de début et de fin ne sont pas définies dans la configuration du budget utilisateur.');
            return;
        }

        try {
            const response = await axios.post('https://app-slfinance.fr/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_consolidated_by_budget_hypothesis_and_years',
                id_budget: props.user.id_budget,
                hypothese: hypotheseKey,
                annee_debut: annee_debut,
                annee_fin: annee_fin
            }));

            if (response.data.status === 1) {
                setIncidencesData(response.data.data);
            } else {
                console.warn('Erreur API:', response.data.message);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des incidences financières:', error);
        }
    }

    // UseEffect pour recuperer les incidences financieres en fonction de props.hypothese.
    useEffect(() => {
        if (props.hypothese !== null && props.user) {
            getDatas();
        }
    }, [props.hypothese, props.user]);

    const filteredIncidencesData = incidencesData || [];

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '15%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Incidences financières</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.hypothese !== null ? '(hypothèse '+props.hypothese+')' : ''} - partie 1</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%', fontSize: fontsize, padding: '0 15px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                {filteredIncidencesData && filteredIncidencesData.length > 0 ? (
                    <div style={{width: '100%', overflowX: 'auto', overflowY: 'auto', flex: 1, borderRadius: '6px', border: '1px solid #ddd', marginTop: '8px', position: 'relative', minWidth: 0}}>
                        <div style={{display: 'flex', minWidth: 'min-content', height: '100%'}}>
                            {/* Colonne Catégorie */}
                            <div style={{width: 40, minWidth: 40, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', fontWeight: 'bold', position: 'sticky', left: 0, top: 0, zIndex: 12}}></div>

                                {/* Dépenses amortissables - 10 lignes */}
                                <div style={{flex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>
                                        Dépenses amortissables
                                    </div>
                                </div>

                                <div style={{flex: 3, display: 'flex'}}></div>

                                {/* Frais de portage - 12 lignes */}
                                <div style={{flex: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>
                                        Frais de portage
                                    </div>
                                </div>
                            </div>

                            {/* Colonne Figée - Libellés */}
                            <div style={{minWidth: 200, maxWidth: 300, backgroundColor: 'transparent', flexShrink: 0, display: 'flex', flexDirection: 'column'}}>
                                {/* Header */}
                                <div style={{display: 'flex', flex: 1, alignItems: 'center', padding: '0 10px', backgroundColor: blue, fontWeight: 'bold', position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                    <p style={{marginTop: (0 - props.marge), color: 'white', margin: 0, fontSize: fontsize-1}}>Libellé (en euro)</p>
                                </div>

                                {/* Lignes */}
                                {[
                                    { key: 'sum_prix_acquisition', label: 'Prix d\'acquisition [A]', compte: '6012', isBold: false, isCalculated: false },
                                    { key: 'sum_frais_actes', label: 'Frais d\'actes [F]', compte: '6012', isBold: false, isCalculated: false },
                                    { key: 'sum_subventions', label: 'Subventions [SUB] (saisir en positif)', compte: '748', isBold: false, isCalculated: false },
                                    { key: 'sum_montant_retrocessions', label: 'Montant rétrocessions [RETRO] (saisir en positif)', compte: '701', isBold: false, isCalculated: false },
                                    { key: 'sum_total_annuel_capital_porte', label: 'Total annuel - capital porté [ST1]', isBold: true, isCalculated: true },
                                    { key: 'sum_frais_prealables', label: 'Frais préalables [FP]', compte: '6012', isBold: false, isCalculated: false },
                                    { key: 'sum_frais_annexes', label: 'Frais annexes [FA]', compte: '6012', isBold: false, isCalculated: false },
                                    { key: 'sum_frais_gegr', label: 'Frais GEGR [GEGR]', compte: '615', isBold: false, isCalculated: false },
                                    { key: 'sum_frais_proto_amenagement', label: 'Frais proto-aménagement [PROTO]', compte: '6012', isBold: false, isCalculated: false },
                                    { key: 'sum_total_annuel_hors_capital_porte', label: 'Total annuel - hors capital porté [ST2]', isBold: true, isCalculated: true },
                                    { key: 'empty_separator', label: '', isEmpty: true },
                                    { key: 'sum_depots_cautionnements_verses', label: 'Dépôts cautionnements versés', isBold: false, isCalculated: false },
                                    { key: 'sum_depots_cautionnements_recus', label: 'Dépôts cautionnements reçus', isBold: false, isCalculated: false },
                                    { key: 'empty_1', label: '', isEmpty: true },
                                    { key: 'sum_annuites_capital_porte', label: 'Annuités sur le capital porté [AKP]', isBold: false, isCalculated: true },
                                    { key: 'sum_annuites_capital_porte_reel', label: 'Annuités capital porté réel [AKP-REEL]', isBold: false, isCalculated: false },
                                    { key: 'sum_annuite_hors_capital_porte', label: 'Annuité hors capital porté [AHKP]', isBold: false, isCalculated: true },
                                    { key: 'sum_annuites_hors_capital_porte_reel', label: 'Annuités hors capital porté réel [AHKP-REEL]', isBold: false, isCalculated: false },
                                    { key: 'sum_annuite_definitive', label: 'Annuité définitive à facturer [AT]', compte: '2763', isBold: true, isCalculated: true },
                                    { key: 'empty_2', label: '', isEmpty: true },
                                    { key: 'sum_capital_stocke', label: 'TOTAL - capital stocké au 31/12 [KS]', isBold: true, isCalculated: true },
                                    { key: 'empty_3', label: '', isEmpty: true },
                                    { key: 'sum_calcul_frais_portage', label: 'Total capital porté au 31/12 [CFP]', compte: '312', isBold: false, isCalculated: true },
                                    { key: 'sum_taux', label: 'Taux applicable au capital 31/12 n-1 (en %)', isBold: false, isCalculated: false },
                                    { key: 'sum_frais_portage_ht', label: 'Frais de portage HT sur capital 31/12 n-1 [FPHT]', isBold: false, isCalculated: true },
                                    { key: 'sum_tva_frais_portage', label: 'TVA sur frais de portage 20% [TVA]', isBold: false, isCalculated: true },
                                    { key: 'sum_frais_portage_ttc', label: 'Frais de portage TTC [FPTTC]', compte: '706', isBold: true, isCalculated: true }
                                ].map((row, idx) => (
                                    <div key={idx} style={{display: 'flex', flex: row.isEmpty ? 0.5 : 1, alignItems: 'center', padding: '0 8px', borderBottom: '1px solid #ddd', backgroundColor: row.isEmpty ? 'transparent' : (row.isCalculated ? '#f0f0f0' : '#ffffff'), left: 0, zIndex: 11}}>
                                        <p style={{marginTop: (0-props.marge), fontSize: fontsize, fontWeight: row.isBold ? 'bold' : 'normal', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                            {row.compte && (
                                                <>
                                                    <span style={{color: 'red'}}>{row.compte}</span>
                                                    {' - '}
                                                </>
                                            )}
                                            {row.label}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            {/* Colonnes de données (années) */}
                            <div style={{display: 'flex', flex: 1}}>
                                {filteredIncidencesData.map((row, yearIdx) => (
                                    <div key={yearIdx} style={{flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0}}>
                                        {/* Header année */}
                                        <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', padding: '0 3px', backgroundColor: blue, fontWeight: 'bold', borderBottom: '1px solid #ddd', position: 'sticky', top: 0, zIndex: 10}}>
                                            <p style={{marginTop: (0 - props.marge), color: 'white', margin: 0, fontSize: fontsize-2}}>
                                                {row.annee}
                                            </p>
                                        </div>

                                        {/* Données lignes */}
                                        {[
                                            { key: 'sum_prix_acquisition', isCalculated: false },
                                            { key: 'sum_frais_actes', isCalculated: false },
                                            { key: 'sum_subventions', isCalculated: false },
                                            { key: 'sum_montant_retrocessions', isCalculated: false },
                                            { key: 'sum_total_annuel_capital_porte', isBold: true, isCalculated: true },
                                            { key: 'sum_frais_prealables', isCalculated: false },
                                            { key: 'sum_frais_annexes', isCalculated: false },
                                            { key: 'sum_frais_gegr', isCalculated: false },
                                            { key: 'sum_frais_proto_amenagement', isCalculated: false },
                                            { key: 'sum_total_annuel_hors_capital_porte', isBold: true, isCalculated: true },
                                            { key: 'empty_separator', isEmpty: true },
                                            { key: 'sum_depots_cautionnements_verses', isCalculated: false },
                                            { key: 'sum_depots_cautionnements_recus', isCalculated: false },
                                            { key: 'empty_1', isEmpty: true },
                                            { key: 'sum_annuites_capital_porte', isCalculated: true },
                                            { key: 'sum_annuites_capital_porte_reel', isCalculated: false },
                                            { key: 'sum_annuite_hors_capital_porte', isCalculated: true },
                                            { key: 'sum_annuites_hors_capital_porte_reel', isCalculated: false },
                                            { key: 'sum_annuite_definitive', isBold: true, isCalculated: true },
                                            { key: 'empty_2', isEmpty: true },
                                            { key: 'sum_capital_stocke', isBold: true, isCalculated: true },
                                            { key: 'empty_3', isEmpty: true },
                                            { key: 'sum_calcul_frais_portage', isCalculated: true },
                                            { key: 'sum_taux', isCalculated: false },
                                            { key: 'sum_frais_portage_ht', isCalculated: true },
                                            { key: 'sum_tva_frais_portage', isCalculated: true },
                                            { key: 'sum_frais_portage_ttc', isBold: true, isCalculated: true }
                                        ].map((rowDef, idx) => {
                                            const displayValue = row[rowDef.key];
                                            
                                            const formatNumber = (num) => {
                                                if (!num || isNaN(num)) return '';
                                                const parsed = parseFloat(num);
                                                return parsed.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                            };

                                            const isZeroOrEmpty = (val) => {
                                                if (!val || val === '') return true;
                                                const parsed = parseFloat(String(val).replace(',', '.'));
                                                return isNaN(parsed) || parsed === 0;
                                            };

                                            return (
                                                <div key={idx} style={{display: 'flex', flex: rowDef.isEmpty ? 0.5 : 1, borderBottom: '1px solid #ccc', alignItems: 'center', justifyContent: 'center', backgroundColor: rowDef.isEmpty ? 'transparent' : '#ffffff'}}>
                                                    {rowDef.isEmpty ? (
                                                        <div></div>
                                                    ) : isZeroOrEmpty(displayValue) ? (
                                                        <div style={{width: '100%', height: '100%', fontSize: fontsize-1, textAlign: 'center', fontWeight: rowDef.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: rowDef.isCalculated ? '#f0f0f0' : '#ffffff', borderLeft: '1px solid #ddd', color: rowDef.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                            <p style={{marginTop: (0 - props.marge)}}>&nbsp;</p>
                                                        </div>
                                                    ) : (
                                                        <div style={{width: '100%', height: '100%', fontSize: fontsize-1, textAlign: 'center', fontWeight: rowDef.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: rowDef.isCalculated ? '#f0f0f0' : '#ffffff', borderLeft: '1px solid #ddd', color: rowDef.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                            <p style={{marginTop: (0 - props.marge)}}>{formatNumber(displayValue)}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                        <p style={{color: '#999', fontSize: fontsize}}>Aucune donnée disponible</p>
                    </div>
                )}
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '5%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page5IncidencesFinancieresHypPart1;
